import api from "./api";

export const listItem = async (params?: any) => {
    const { data } = await api.get('products/item/', {params: params});

    return data
}

export const detailItem = async (id: string) => {
    const { data } = await api.get('products/item/'+ id);

    return data
}

// Manarger Services
export const detailItemManager = async (id: string) => {
    const { data } = await api.get('manager/item/'+ id);

    return data
}

export const getGroupedItemManager = async () => {
    const { data } = await api.get('manager/discipline/grouped_items/');
    return data
}

export const setMediasToItemManager = async (params: any) => {
    const { data } = await api.post('manager/item/medias/', params);
    return data
}

export const listAllShortItemsThemeManager = async (params?: any) => {
    const { data } = await api.get('manager/short_materials/all_items/', {params: params});
    return data
}

export const listAllItemsThemeManager = async (params?: any) => {
    const { data } = await api.get('manager/materials/all_items/', {params: params});
    return data
}